jQuery(document).ready(function(){

    var cpcSliderContainer = jQuery('.cpc-slider-container');

    cpcSliderContainer.each( function(){
        jQuery(this).find('.cpc-slider').slick({
        });
    } );
  });